import { z } from "zod";
import { ProductApiId, toProductApiRoot } from "./api-routes";

export const JARVIS_REMOTE_FILE_MAX_BYTES = 10 * 1024 * 1024;
export const JARVIS_REMOTE_FILE_USER_QUOTA_BYTES = 20 * 1024 * 1024;
export const JARVIS_REMOTE_FILE_CHUNK_BYTES = 512 * 1024;
export const JARVIS_REMOTE_FILE_TTL_SECONDS = 600;
export const JarvisRemoteFileCreateSchema = z.object({
  fileName: z.string().min(1).max(256).refine((value) => value !== "." && value !== ".." && !/[\u0000-\u001f\u007f/\\]/.test(value)),
  mimeType: z.string().min(3).max(160).regex(/^[a-z\d!#$&^_.+-]+\/[a-z\d!#$&^_.+-]+$/i),
  size: z.number().int().min(0).max(JARVIS_REMOTE_FILE_MAX_BYTES),
  sha256: z.string().regex(/^[a-f\d]{64}$/),
}).strict();
export const JarvisRemoteFileUploadSchema = z.object({
  uploadId: z.uuid(), expiresAt: z.iso.datetime({ offset: true }), chunkBytes: z.literal(JARVIS_REMOTE_FILE_CHUNK_BYTES),
});
export const JarvisRemoteFileChunkSchema = z.object({
  offset: z.number().int().min(0).max(JARVIS_REMOTE_FILE_MAX_BYTES),
  base64: z.string().min(4).max(Math.ceil(JARVIS_REMOTE_FILE_CHUNK_BYTES / 3) * 4).regex(/^[A-Za-z\d+/]+={0,2}$/),
}).strict();
export const JarvisRemoteFileIdSchema = z.object({ id: z.uuid() });
export const JarvisRemoteFileGrantSchema = z.object({
  fileId: z.uuid(), downloadPath: z.string().startsWith(`${toProductApiRoot(ProductApiId.Jarvis)}/files/`).max(512),
  expiresAt: z.iso.datetime({ offset: true }),
});
export const JarvisRemoteFileDownloadQuerySchema = z.object({ token: z.string().regex(/^[A-Za-z\d_-]{43}$/) });
export const JarvisRemoteFileSuccessSchema = z.object({ success: z.literal(true) });
export type JarvisRemoteFileCreate = z.infer<typeof JarvisRemoteFileCreateSchema>;
export type JarvisRemoteFileChunk = z.infer<typeof JarvisRemoteFileChunkSchema>;
export type JarvisRemoteFileGrant = z.infer<typeof JarvisRemoteFileGrantSchema>;
